<template>
    <!--Top Bar-->
    <LoadingView v-if="loading" />
    <!--web view-->
    <v-layout class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block web-brand">
        <v-app-bar scroll-behavior="hide" :elevation="0" height="100" absolute flat color="background">
            <v-container>
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">

                        <div class="justify-center mt-2">
                            <img alt="logo" :src="brandDetails.logo" height="75" contain
                                v-if="userLogin == true && loading == false" />
                            <v-skeleton-loader type="image" v-if="userLogin == false || loading" height="90" width="150"
                                class="mb-3"></v-skeleton-loader>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="7" md="7">
                        <div class="mt-6 justify-center rounded-pill">
                            <form @submit.prevent="searchProduct">
                                <v-text-field prepend-inner-icon="mdi-magnify" variant="outlined" label="Search Product"
                                    rounded="5" rounded-pill class="rounded-pill search-field primary" base-color="primary"
                                    density="compact" @click:prepend-inner="searchProduct" v-model="search"></v-text-field>
                            </form>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <div class="mt-7 justify-center">
                            <v-btn color="primary" icon class="mr-3" @click="cartDialog = true" variant="flat" size="small">
                                <v-badge floating  color="orange" :content=getCartCount> <v-icon color="white">mdi-cart-outline</v-icon></v-badge>
                            </v-btn>
                            <v-menu transition="slide-x-reverse-transition">
                                <template v-slot:activator="{ props }">
                                    <v-btn variant="flat" color="black" v-bind="props" rounded="pill">
                                        <v-icon color="white">mdi-account-circle-outline</v-icon> &nbsp;My Account
                                    </v-btn>
                                </template>
                                <v-sheet elevation="12" max-width="350" rounded="lg" class="text-left mx-auto"
                                    color="white">
                                    <div class="pa-5">
                                        <h2 class="text-h5 text-black font-weight-bold mb-1">Welcome {{ username }}</h2>
                                        <p class="mb-4 text-black text-body-2" v-if="username=='Guest'">
                                            Register to enjoy the best features, offers and more
                                        </p>
                                        <p class="mb-4 text-black text-body-2" v-else>
                                            Explore our wide range of fresh and organic produce
                                        </p>
                                        <div class="text-start" v-if="userLogin == false">
                                            <!--<v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                                color="primary" width="120" rounded variant="flat" href="/register">
                                                <p class="text-white"> REGISTER</p>
                                            </v-btn>-->
                                            <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn"
                                                color="black" rounded variant="flat" width="100" href="/login">
                                                LOGIN
                                            </v-btn>
                                        </div>
                                        <div class="text-start" v-if="userLogin == true">
                                            <v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                                color="primary" width="120" rounded variant="flat"
                                                @click="logoutDialog = true">
                                                <p class="text-white"> LOGOUT</p>
                                            </v-btn>
                                        </div>
                                    </div>
                                    <v-divider></v-divider>
                                    <div class="text-start bg-white" v-if="userLogin == true">
                                        <v-list lines="two" class="bg-white">
                                            <v-list-item title="My Orders" subtitle="See your current/past orders"
                                                prepend-icon="mdi-receipt-text-outline" @click="orderDialog = true">
                                            </v-list-item>
                                            <v-list-item title="My Profile" subtitle="Change/view your address"
                                                prepend-icon="mdi-map-marker-outline" @click="addressDialog = true">
                                            </v-list-item>
                                        </v-list>
                                    </div>
                                </v-sheet>
                            </v-menu>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-app-bar>
    </v-layout>
    <!--web view end-->

    <!--Mobile View-->
    <div class="d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none">
        <v-toolbar color="primary" height="145">
            <v-container>
                <v-row dense>
                    <v-col cols="3">
                        <div class="justify-center mt-n6">
                            <img alt="logo" :src="brandDetails.logo" height="50" contain
                                v-if="userLogin == true && loading == false" />
                            <v-skeleton-loader type="image" v-if="userLogin == false || loading"
                                height="75"></v-skeleton-loader>
                        </div>
                    </v-col>
                    <v-col cols="9">
                        <div class="justify-right text-right mt-n5">
                            <v-btn color="white" class="text-capitalize" @click="locationDialog = true"
                                v-if="userLogin == false">
                                <p class="location-text"> {{ locationDetails.name }} <v-icon icon="mdi-near-me"></v-icon>
                                </p>
                            </v-btn>

                            <v-btn color="white" class="text-capitalize" v-if="userLogin == true">
                                <p class="location-text"> {{ locationDetails.name }} <v-icon icon="mdi-near-me"></v-icon>
                                </p>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-toolbar>
        <v-row dense class="search-bar ma-3 mt-n12">
            <v-col cols="7">
                <div class="justify-center rounded-pill">
                    <form @submit.prevent="searchProduct">
                        <v-text-field append-inner-icon="mdi-magnify" variant="outlined" label="Search Product" rounded="5"
                            rounded-pill class="rounded-pill search-field primary" base-color="primary" bg-color="white"
                            density="compact" @click:prepend-inner="searchProduct" v-model="search"></v-text-field>
                    </form>
                </div>
            </v-col>
            <v-col cols="5">
                <div class="justify-center">
                    <v-btn color="background" icon class="mr-3" @click="cartDialog = true" variant="flat" size="large"
                        density="comfortable">
                        <v-badge floating  color="orange" :content=getCartCount> <v-icon color="black">mdi-cart-outline</v-icon></v-badge>
                    </v-btn>
                    <v-menu transition="slide-x-reverse-transition">
                        <template v-slot:activator="{ props }">
                            <v-btn variant="flat" color="background" v-bind="props" rounded="pill" icon size="large"
                                density="comfortable">
                                <v-icon color="black">mdi-account-circle-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-sheet elevation="12" max-width="350" rounded="lg" class="text-left mx-auto" color="white">
                            <div class="pa-5">
                                <h2 class="text-h5 text-black font-weight-bold mb-1">Welcome {{ username }}</h2>
                                <p class="mb-4 text-black text-body-2" v-if="username=='Guest'">
                                    Register to enjoy the best features, offers and more
                                </p>
                                <p class="mb-4 text-black text-body-2" v-else>
                                    Explore our wide range of fresh and organic produce
                                </p>
                                <div class="text-start" v-if="userLogin == false">
                                    <v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                        color="primary" width="120" rounded variant="flat" href="/register">
                                        <p class="text-white"> REGISTER</p>
                                    </v-btn>
                                    <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black"
                                        rounded variant="flat" width="100" href="/login">
                                        LOGIN
                                    </v-btn>
                                </div>
                                <div class="text-start" v-if="userLogin == true">
                                    <v-btn class="text-none text-subtitle-2 font-weight-bold mr-5 account-btn"
                                        color="primary" width="120" rounded variant="flat" @click="logoutDialog = true">
                                        <p class="text-white"> LOGOUT</p>
                                    </v-btn>
                                </div>
                            </div>
                            <v-divider></v-divider>
                            <div class="text-start bg-white">
                                <v-list lines="two" class="bg-white">
                                    <v-list-item title="My Orders" subtitle="See your current/past orders"
                                        prepend-icon="mdi-receipt-text-outline" @click="orderDialog = true">
                                    </v-list-item>
                                    <v-list-item title="My Profile" subtitle="Change/view your address"
                                        prepend-icon="mdi-map-marker-outline" @click="addressDialog = true">
                                    </v-list-item>
                                </v-list>
                            </div>
                        </v-sheet>
                    </v-menu>
                </div>
            </v-col>
        </v-row>
    </div>
    <!--Mobile View End-->

    <!--login Dialog-->
    <v-dialog width="500" v-model="loginDialog" class="" persistent>
        <v-card class="text-center justify-center align-center rounded-xl" min-height="350" color="white">
            <div class="pa-4 justify-center align-center">
                <h2 class="text-h5 text-black font-weight-bold mb-3">Welcome to {{brandDetails.name}}</h2>
                <p class="mb-4 text-black text-h6">
                    Login
                </p>
                <!--alert box-->
                <v-alert type="error" class="text-left ma-5" border v-if="loginStatusmsg">
                    <div v-for="(resp, i) in loginStatusResponse" :key="i">
                        {{ resp }}
                    </div>
                </v-alert>
                <!--alert box end-->
                <form class="mt-5">
                    <v-text-field v-model="mobileno" :error-messages="v$.mobileno.$errors.map(e => e.$message)"
                        :counter="10" label="Mobile no" required @input="v$.mobileno.$touch" @blur="v$.mobileno.$touch"
                        variant="outlined" color="black" type="number" class="mb-2"></v-text-field>
                    <v-text-field v-model="password" :error-messages="v$.password.$errors.map(e => e.$message)"
                        label="Password" required @input="v$.password.$touch" @blur="v$.password.$touch" variant="outlined"
                        color="black" type="password" class="mb-2"></v-text-field>
                    <v-btn class="text-none text-subtitle-2 font-weight-bold mb-5 cart-btn float-left" color="primary"
                        rounded variant="flat" block width="220" @click="submit">
                        <p class="text-white"> LOGIN</p>
                    </v-btn>
                    <v-btn class="text-subtitle-2 font-weight-bold" variant="text" href="https://www.sigmafarmersmarket.com/partner-with-us/"> 
                        New User? Click here to &nbsp;<span class="text-decoration-underline" color="black"> Register</span>
                    </v-btn>
                </form>
            </div>
        </v-card>
    </v-dialog>
    <!--login Dialog End-->

    <!--Logout Dialog-->
    <v-dialog width="500" v-model="logoutDialog" class="" persistent>
        <v-card color="white" class="ma-5 pa-5 text-center">
            <v-card-title class="text-h5">
                Are you sure want to Logout?
            </v-card-title>

            <v-card-actions class="mt-3 justify-center">
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="warning" variant="flat" rounded
                    @click="logout" width="120">
                    LOGOUT
                </v-btn>
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat" rounded
                    @click="logoutDialog = false" width="100">
                    CLOSE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--Logout Dialog End-->

    <!--Brand Cart Component Dialog-->
    <v-dialog v-model="cartDialog" class="" min-width="375" max-width="1100">
        <v-card color="white" class="text-center">
            <v-toolbar dark color="white">
                <v-spacer></v-spacer>
                <v-btn icon dark @click="cartDialog = false; refreshProduct();" variant="flat" color="secondary">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <CartComponentView />
            <div v-if="getCart.total_amount > 0" class="text-left">
                <v-btn class="text-none text-subtitle-2 font-weight-bold mb-5 ml-3 cart-btn" color="primary" rounded
                    variant="flat" width="220" v-if="userLogin == false" @click="loginDialog = true">
                    <p class="text-white">LOGIN</p>
                </v-btn>
            </div>

        </v-card>
    </v-dialog>
    <!--Brand Cart Component Dialog End-->

    <!--Brand Order Component Dialog-->
    <v-dialog v-model="orderDialog" class="" max-width="1100">
        <v-card color="white" class="text-center">
            <v-toolbar dark color="white">
                <v-spacer></v-spacer>
                <v-btn icon dark @click="orderDialog = false" variant="flat" color="secondary">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <BrandOrderView />
        </v-card>
    </v-dialog>
    <!--Brand Cart Component Dialog End-->

    

    
    <!--Brand My Profile Component Dialog-->
    <v-dialog width="500" v-model="addressDialog" class="rounded-xl" persistent height="auto">
        <v-card color="white" class="ma-5 pa-5 text-center">
            <v-card-title class="text-h5 mb-3">
                My Profile
            </v-card-title>



            <v-text-field v-model="profile_name" :error-messages="v$.profile_name.$errors.map(e => e.$message)" label="Name*"
                required @input="v$.profile_name.$touch" @blur="v$.profile_name.$touch" variant="outlined" color="black"
                class="mb-2" type="text"></v-text-field>


            <v-text-field v-model="profile_email" :error-messages="v$.profile_email.$errors.map(e => e.$message)" label="Email"
                @input="v$.profile_email.$touch" @blur="v$.profile_email.$touch" variant="outlined" color="black" class="mb-2"
                type="text"></v-text-field>

            <v-text-field v-model="profile_flat_door_no" :error-messages="v$.profile_flat_door_no.$errors.map(e => e.$message)"
                label="Flat / Door No*" required @input="v$.profile_flat_door_no.$touch" @blur="v$.profile_flat_door_no.$touch"
                variant="outlined" color="black" class="mb-2"></v-text-field>


            <v-text-field v-model="profile_address" :error-messages="v$.profile_address.$errors.map(e => e.$message)"
                label="Address*" required @input="v$.profile_address.$touch" @blur="v$.profile_address.$touch" variant="outlined"
                color="black" class="mb-2"></v-text-field>

            <v-text-field v-model="profile_address2" label="Address 2" variant="outlined" color="black"
                class="mb-2"></v-text-field>

            <v-select v-model="profile_locality_id" :items="getLocality" item-title="name" item-value="id" label="Locality"
                variant="outlined" color="black"></v-select>

            <v-text-field v-model="profile_pincode" :error-messages="v$.profile_pincode.$errors.map(e => e.$message)"
                label="Pincode*" required @input="v$.profile_pincode.$touch" @blur="v$.profile_pincode.$touch" variant="outlined"
                color="black" class="mb-2"></v-text-field>

            <v-text-field v-model="profile_geo_location"  label="Geo Location" variant="outlined"
                color="black" class="mb-2"></v-text-field>

            <v-divider></v-divider>

            <v-card-actions class="mt-3 text-center justify-left">
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="primary" variant="flat"
                    rounded @click="addressFormUpdate" width="120">
                    <p class="text-white">UPDATE</p>
                </v-btn>
                <v-btn class="text-none text-subtitle-2 font-weight-bold account-btn" color="black" variant="flat"
                    rounded @click="addressDialog = false" width="100">
                    CLOSE
                </v-btn>
            </v-card-actions>

            <!--alert box-->
            <v-alert type="success" v-if="addressStatusmsg" class="mt-3 text-left" border color="primary"
                min-height="55">
                <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                    {{ addressStatusResponse }}
                </div>

                <div class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                    {{ addressStatusResponse }}
                </div>
            </v-alert>
            <div v-if="addressErrorStatusmsg" class="mt-3">
                <v-alert type="error" v-for="(resp, i) in addressStatusResponse" :key="i" class="mb-1 text-left"
                    border min-height="55">
                    <div class="text-white d-none  d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
                        {{ resp }}
                    </div>

                    <div
                        class="text-white d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none mb-2 alert-text">
                        {{ resp }}
                    </div>
                </v-alert>
            </div>

            <!--alert box end-->
        </v-card>
    </v-dialog>
    <!--Brand My Profile Component Dialog End-->

    <!--Top Bar End-->

    <!--Body Content Start-->
    <div class="category bg-background">
        <!--<v-card elevation="0" rounded="0"
            class="bg-primary mx-auto d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block" height="150">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="category-title-text text-white">
                    {{ brandDetails.name }}
                </h1>
            </div>
        </v-card>
        <v-card elevation="0"
            class="bg-secondary mx-auto rounded-xl mt-n6 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none "
            height="100">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="mobile-category-title-text">
                    {{ brandDetails.name }}
                </h1>
            </div>
        </v-card>-->
        <v-divider></v-divider>

        <!--web banner-->
        <div class="mt-n6 d-block d-md-block d-md-block d-lg-block d-xl-block d-xxl-block">
            <v-carousel hide-delimiters height="auto" :show-arrows="false">
                <v-carousel-item v-for="(banner, i) in brandBannersDetails" :key="i" :src="banner" cover></v-carousel-item>
            </v-carousel>
        </div>
        <!--web banner-->
        <v-container>
            <v-row dense>
                <v-col cols="12" sm="12" md="12">
                    <!--Web View screen-->
                    <!-- <v-card elevation="0"
                        class="bg-background rounded-xl mx-auto d-none d-sm-block d-md-block d-lg-block mt-n8"
                        max-width="1100"> -->
                    <v-card elevation="0"
                        class="bg-background rounded-xl mx-auto d-none d-sm-block d-md-block d-lg-block mt-1"
                        max-width="1100">
                        <v-container>
                            <v-row dense no-gutters>
                                <v-col cols="1"></v-col>
                                <v-col cols="8" sm="12" md="12" lg="12">
                                    <v-sheet min-width="600" max-width="1150">
                                        <div class="d-sm-flex d-md-flex d-lg-flex flex-wrap justify-left bg-background">
                                            <ProductCard :products="brandProductList" v-if="!loading" />
                                            <p v-if="brandProductList.length == 0" class="mx-auto ma-10 text-h6"> No
                                                Products
                                                Found </p>
                                            <v-container v-if="userLogin == false || loading">
                                                <v-row>
                                                    <v-col cols="12" md="3" v-for="n in 8" :key="n">
                                                        <v-skeleton-loader class="mx-auto border" max-width="300"
                                                            type="image, article"></v-skeleton-loader>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </div>
                                    </v-sheet>
                                </v-col>
                            </v-row>
                            <v-row dense no-gutters  v-if="brandAddonProductList.length != 0">
                                <v-col cols="12" sm="12" md="12">
                                    <v-card class="ma-1 mx-auto rounded-xl bg-background" elevation="0">
                                        <div class="cart-block">
                                            <v-col cols="12" sm="12" md="12">
                                                <div class="web-title">
                                                    Add On Products
                                                </div>
                                                <p class="text-center">
                                                    The add ons can be purchased only when at least one veggie box is added to your cart
                                                </p>
                                            </v-col>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="8" sm="12" md="12" lg="12">
                                    <v-sheet min-width="600" max-width="1150">
                                        <div class="d-sm-flex d-md-flex d-lg-flex flex-wrap justify-left bg-background">
                                            <ProductCard :products="brandAddonProductList" />
                                            <p v-if="brandAddonProductList.length == 0" class="mx-auto ma-10 text-h6"> No
                                                Products
                                                Found </p>
                                        </div>
                                    </v-sheet>
                                </v-col>
                            </v-row>

                        </v-container>
                    </v-card>
                    <!--Web View Screen End-->

                    <!--Mobile View Tab screen-->
                    <!-- <v-card elevation="0"
                        class="bg-background rounded-xl mx-auto d-block d-sm-none d-md-none d-lg-none mt-n8"
                        max-width="1100"> -->
                    <v-card elevation="0"
                        class="bg-background rounded-xl mx-auto d-block d-sm-none d-md-none d-lg-none mt-1"
                        max-width="1100">
                        <v-row dense>
                            <v-col cols="12">
                                <v-sheet min-width="340" max-width="1100">
                                    <div
                                        class="d-flex d-sm-flex d-md-flex d-lg-flex flex-wrap align-content-left justify-left align-left bg-background">
                                        <ProductCard :products="brandProductList" v-if="!loading" />
                                        <p v-if="brandProductList.length == 0" class="mx-auto ma-10 text-h6"> No
                                            Products
                                            Found </p>
                                        <v-container v-if="userLogin == false || loading">
                                            <v-row>
                                                <v-col cols="6" md="3" v-for="n in 4" :key="n">
                                                    <v-skeleton-loader class="mx-auto border" max-width="300"
                                                        type="image, article"></v-skeleton-loader>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </div>
                                </v-sheet>
                            </v-col>
                        </v-row>

                        <v-row dense no-gutters v-if="brandAddonProductList.length != 0">
                            <v-col cols="12" sm="12" md="12">
                                <v-card class="ma-1 mx-auto rounded-xl bg-background" elevation="0">
                                    <div class="cart-block">
                                        <v-col cols="12" sm="12" md="12">
                                            <div class="mobile-title text-center ml-1">
                                                Add On Products
                                            </div>
                                            <p class="text-center">
                                                The add ons can be purchased only when at least one veggie box is added to your cart
                                            </p>
                                        </v-col>
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col cols="812" sm="12" md="12" lg="12">
                                <v-sheet min-width="340" max-width="1100">
                                    <div
                                        class="d-flex d-sm-flex d-md-flex d-lg-flex flex-wrap align-content-left justify-left align-left bg-background">
                                        <ProductCard :products="brandAddonProductList" />
                                        <p v-if="brandAddonProductList.length == 0" class="mx-auto ma-10 text-h6"> No
                                            Products
                                            Found </p>
                                    </div>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-card>
                    <!--Mobile View Tab screen End-->

                </v-col>
            </v-row>
        </v-container>
    </div>
    <!--Body Content End-->

    <!--Footer Start-->

    <v-snackbar v-model="stocksnackbar" :timeout="timeout" class="mb-10">
        <div v-for="(resp, i) in cartStatusResponse" :key="i">
            {{ resp }}
        </div>
        <template v-slot:actions>
            <v-btn color="blue" variant="text" @click="closeStocksnackbar">
                Close
            </v-btn>
        </template>
    </v-snackbar>
    <v-layout>
        <v-footer class="bg-primary">
            <v-row justify="center" no-gutters>
                <v-col class="text-center mt-4 d-none" cols="12"></v-col>
                <v-col class="text-center mt-4 d-none" cols="12"></v-col>
                <v-col class="text-center mt-4 mb-5" cols="12">
                    <v-btn v-for="icon in icons" :key="icon" class="mx-4" :icon="icon" variant="text" color="white"></v-btn>
                </v-col>
                <v-divider class="mt-3 border-opacity-25" color="white"></v-divider>
                <v-col class="text-right mt-4 text-white footer-text" cols="12">
                    © {{ new Date().getFullYear() }} Sigma.. All Rights Reserved. Developed By AGT
                </v-col>
            </v-row>
        </v-footer>
    </v-layout>

    <!--Footer End-->
    <!-- <v-snackbar v-model="stocksnackbar" :timeout="timeout" class="mb-10">
        <div v-for="(resp, i) in cartStatusResponse" :key="i">
            {{ resp }}
        </div>
        <template v-slot:actions>
            <v-btn color="blue" variant="text" @click="closeStocksnackbar">
                Close
            </v-btn>
        </template>
    </v-snackbar> -->
</template>

<style>
.web-title {
    font-size: 42px;
    font-weight: bold;
}

.mobile-title {
    font-size: 18px;
    font-weight: 800;
}

.web-brand {
    margin-bottom: 100px;
}

.category-title-text {
    font-size: 35px;
}

.mobile-category-title-text {
    font-size: 22px;
}

.category-tab {
    border-radius: 10px;
}

.mobile-tab .v-tab {
    font-size: 10px !important;
}

.category-active {
    background-color: #000 !important;
    color: #fff !important;
}

.web-chip-text {
    font-size: 12px !important;
}

.mobile-chip-text {
    font-size: 10px !important;
}

.price-text {
    letter-spacing: 0px !important;
}

.product-card-actions {
    bottom: 0 !important;
    position: absolute;
}

.mobile-product-title {
    font-size: 12px !important;
}

.footer-text {
    font-size: 13px !important;
}
</style>

<script>
// @ is an alias to /src

import { mapActions, mapGetters } from "vuex";
import store from "../store";

import { useVuelidate } from '@vuelidate/core';
import { required, numeric, email, minLength, maxLength, helpers } from '@vuelidate/validators'

import CartComponentView from '@/components/BrandCart.vue';
import ProductCard from '@/components/Product.vue'
import BrandOrderView from '@/components/BrandOrder.vue';
import LoadingView from '@/components/Loading.vue'
export default {
    name: 'BrandStoreView',
    setup: () => ({ v$: useVuelidate() }),
    data: () => ({
        locationDialog: false,
        logoutDialog: false,
        loginDialog: false,
        currentLocationId: '',
        locationChange: false,
        cartDialog: false,
        orderDialog: false,
        stocksnackbar: false,
        addressDialog: false,
        timeout: 2000,
        mobileno: '',
        password: '',
        search: '',
        icons: [],
        links: [],
        username: (localStorage.getItem('user-token') !== null) ? localStorage.getItem('user-name') : 'Guest',

    }),
    validations() {
        return {

            mobileno: {
                required: helpers.withMessage('This field cannot be empty', required),
                numeric,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            password: { required: helpers.withMessage('This field cannot be empty', required) },
            
            profile_name: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            profile_email: { email },
            profile_flat_door_no: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            profile_address: {
                required: helpers.withMessage('This field cannot be empty', required)
            },
            //profile_locality_id: {
            // required: helpers.withMessage('This field cannot be empty', required)
            // },
            profile_pincode: {
                required: helpers.withMessage('This field cannot be empty', required),
                numeric,
                minLength: minLength(6),
                maxLength: maxLength(6),
            },
        }
    },
    components: {
        CartComponentView,
        ProductCard,
        BrandOrderView,
        LoadingView,
    },
    created() {

        this.$watch(
            () => this.$route.params,
            () => {
                const branddetail = {
                    brandslug: this.$route.params.brandname,
                    brandstore: true,
                };
                this.getBrandDetails(branddetail);
                // this.getBrandProduct(this.$route.params.brandname);
                const searchData = {
                    brandslug: this.$route.params.brandname,
                    search: this.search,
                    brandstore: true, 
                };

                this.getBrandProduct(searchData);
                this.getBrandAddonProduct(searchData);
            },
            // fetch the data when the view is created and the data is
            // already being observed
            { immediate: true }
        )

        if (this.userLogin == false) {
            this.loginDialog = true;
        }

        this.currentLocationId = store.getters.UserLocation;
        this.currentLocationName = localStorage.getItem('currentLocationName');

        this.getlocationDetails();
        this.addressDetails();
        this.cartcount();

        this.$store.subscribe((mutation) => {
            if (mutation.type === "cartError") {
                this.stocksnackbar = true;
            }
        });

    },
    computed: {
        ...mapGetters([
            "locationList",
            "locationDetails",
            "brandDetails",
            "brandProductList",
            "UserLocation",
            "getUserToken",
            "getLoginStatus",
            "getLoginResponse",
            "getCart",
            "getCartStatus",
            "getCartResponse",
            "brandStatus",
            "brandAddonProductList",
            "brandBannersDetails",
            "getCartCount",
            "getAddress",
            "getLocality",
            "getAddressStatus",
            "getAddressResponse",
        ]),
        loading: function () {
            //console.log(this.brandStatus);
            return this.brandStatus === "loading";
        },
        cartStatusResponse: function () {
            return this.getCartResponse;
        },
        loginStatusmsg: function () {
            return this.getLoginStatus === "error";
        },
        loginStatusResponse: function () {
            return this.getLoginResponse;
        },
        userLogin: function () {
            return this.getUserToken != "";
        },
        addressStatusmsg: function () {
            return this.getAddressStatus === "success";
        },
        addressErrorStatusmsg: function () {
            return this.getAddressStatus === "error";
        },
        addressStatusResponse: function () {
            return this.getAddressResponse;
        },
        profile_name: {
            get() {
                return this.getAddress.name;
            },
            set(value) {
                this.$store.commit("updateCustomerName", value);
            }
        },
        profile_email: {
            get() {
                return this.getAddress.email;
            },
            set(value) {
                this.$store.commit("updateCustomerEmail", value);
            }
        },
        profile_flat_door_no: {
            get() {
                return this.getAddress.flat_door_no;
            },
            set(value) {
                this.$store.commit("updateCustomerFlat", value);
            }
        },
        profile_address: {
            get() {
                return this.getAddress.address;
            },
            set(value) {
                this.$store.commit("updateCustomerAddress", value);
            }
        },
        profile_address2: {
            get() {
                return this.getAddress.address2;
            },
            set(value) {
                this.$store.commit("updateCustomerAddress2", value);
            }
        },
        profile_locality_id: {
            get() {
                return this.getAddress.locality_id;
            },
            set(value) {
                this.$store.commit("updateCustomerLocalityId", value);
            }
        },
        profile_pincode: {
            get() {
                return this.getAddress.pincode;
            },
            set(value) {
                this.$store.commit("updateCustomerPincode", value);
            }
        },
        profile_geo_location: {
            get() {
                return this.getAddress.geo_location;
            },
            set(value) {
                this.$store.commit("updateCustomerGeoLocation", value);
            }
        },
    },
    methods: {
        ...mapActions([
            "getlocationDetails",
            "brandLoginAction",
            "getBrandProduct",
            "getBrandDetails",
            "logoutAction",
            "getBrandAddonProduct",
            "cartcount",
            "addressDetails",
            "addressUpdate",
        ]),
        async submit() {
            await this.v$.$validate()
            // const result = await this.v$.$validate()
            // if (!result) {
            //     // notify user form is invalid
            //     console.log('enter');
            //     return
            // }

            if (this.v$.mobileno.$invalid ||
                this.v$.password.$invalid) {
                // notify user form is invalid
                console.log('enter');
                return
            }
            // perform async actions

            const loginData = {
                mobileno: this.mobileno,
                password: this.password
            };

            //console.log(customerData);
            this.brandLoginAction(loginData);
        },
        async addressFormUpdate() {
            await this.v$.$validate()
            //const result = await this.v$.$validate()
            //console.log(this.v$.name);
            //console.log(this.v$.name.$invalid);
            if (this.v$.profile_name.$invalid ||
                this.v$.profile_flat_door_no.$invalid ||
                this.v$.profile_address.$invalid ||
                //this.v$.profile_locality_id.$invalid ||
                this.v$.profile_pincode.$invalid) {
                // notify user form is invalid
                console.log('enter');
                return
            }
            // perform async actions

            const addressData = {
                name: this.profile_name,
                email: this.profile_email,
                flat_door_no: this.profile_flat_door_no,
                address: this.profile_address,
                address2: this.profile_address2,
                locality_id: this.profile_locality_id,
                pincode: this.profile_pincode,
                geo_location: this.profile_geo_location
            };

            //console.log(addressData);
            this.addressUpdate(addressData);
        },
        searchProduct() {
            if (this.search) {
                const searchData = {
                    brandslug: this.$route.params.brandname,
                    search: this.search,
                    brandstore: true, 
                };
                this.getBrandProduct(searchData);
                this.getBrandAddonProduct(searchData);
            }
        },
        refreshProduct() {
            const searchData = {
                brandslug: this.$route.params.brandname,
                search: this.search,
                brandstore: true, 
            };
            this.getBrandProduct(searchData);
            this.getBrandAddonProduct(searchData);
        },
        logout() {
            this.logoutAction();
        },
        closeStocksnackbar() {
            this.stocksnackbar = false;
        }
    },
}
</script>
